export enum ProjectInstallationStatusEnum {
    APPROVED = 'APPROVED',
    PENDING = 'PENDING',
}

export enum ProjectInstallationTimelineEnums {
    CLIENT_INSTALLATION_CREATED = 'CLIENT_INSTALLATION_CREATED',
    CLIENT_INSTALLATION_UPDAETD = 'CLIENT_INSTALLATION_UPDATED',
    CLIENT_INSTALLATION_DELETED = 'CLIENT_INSTALLATION DELETED',

    PROJECT_INSTALLATION_CREATED = 'PROJECT_INSTALLATION_CREATED',
    PROJECT_INSTALLATION_UPDAETD = 'PROJECT_INSTALLATION_UPDATED',
    PROJECT_INSTALLATION_DELETED = 'PROJECT_INSTALLATION DELETED',

    SITE_RECCE_CREATED = 'SITE_RECCE_CREATED',
    SITE_RECCE_UPDATED = 'SITE_RECCE_UPDATED',
    SITE_RECCE_DELETED = 'SITE_RECCE_DELETED',

    ASSET_PURCHASE_ORDER_CREATED = 'ASSET_PURCHASE_ORDER_CREATED',
    ASSET_PURCHASE_ORDER_UPDATED = 'ASSET_PURCHASE_ORDER_UPDATED',
    ASSET_PURCHASE_ORDER_DELETED = 'ASSET_PURCHASE_ORDER_DELETED',
}
